export function useAutoFadeImages(total: number, intervalMs = 4000) {
  const activeIndex = ref(0);
  let timer: ReturnType<typeof setInterval> | null = null;

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    stop();

    if (total <= 1) {
      activeIndex.value = 0;
      return;
    }

    timer = setInterval(() => {
      activeIndex.value = (activeIndex.value + 1) % total;
    }, intervalMs);
  }

  onMounted(start);
  onUnmounted(stop);

  return {
    activeIndex,
  };
}
